$(document).ready(function () {
  //setTimeout(function () { initAutoSearchcomplete(); }, 1000);
});

function initAutoSearchcomplete() {
  // Create the autocomplete object, restricting the search predictions to
  // geographical location types.

  var autocomplete = new google.maps.places.Autocomplete(
      document.getElementById('searchAddress'),
      { types: ['establishment'], componentRestrictions: { country: "us" }, placeholder: undefined });
 
}
